document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.roma-mobile-toggle');
  const menu = document.getElementById('romaMobileMenu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
    });
  }
});
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-roma-picker-button]');
  const picker = event.target.closest('.roma-picker');

  document.querySelectorAll('.roma-picker.is-open').forEach(function (openPicker) {
    if (openPicker !== picker) {
      openPicker.classList.remove('is-open');
    }
  });

  if (button && picker) {
    event.preventDefault();
    picker.classList.toggle('is-open');
    return;
  }

  if (!picker) {
    document.querySelectorAll('.roma-picker.is-open').forEach(function (openPicker) {
      openPicker.classList.remove('is-open');
    });
  }
});